import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { CardBody, Col, Container, Row } from "reactstrap";
import Card from "components/PurpleTheme/Card";
import { Spinner } from 'reactstrap'; // You can use Bootstrap's Spinner component

//redux
import { useDispatch, useSelector } from "react-redux";
import withRouter from "components/Common/withRouter";

// actions
import { initiateOktaLoginFlow } from "../../store/actions";
import { useLocation } from 'react-router-dom';

const OktaCallBackComp = props => {

  //meta title
  document.title = "Login | Temperstack";

  const dispatch = useDispatch();
  // const location = useLocation();
  // const searchParams = new URLSearchParams(location.search);
  // const client_subdomain = searchParams.get('code');
  // const state = searchParams.get('state');
  // const redirectUri = window.location.origin + '/okta-callback';
  //
  // useEffect(() => {
  //   let payload = {
  //     code: client_subdomain,
  //     state: state,
  //     redirect_uri: redirectUri
  //   }
  //   dispatch(initiateOktaLoginFlow(payload))
  // }, []);

  return (
    <React.Fragment>
      <div className="my-3 pt-sm-3" style={{display: "flex", justifyContent: "flex-start", height: "100vh"}}>
        <Container fluid>
          <Row className="justify-content-center why-bluejay">
            <Col lg={12}>
              <Card className="overflow-hidden mt-4">
                <CardBody className="">
                  <div className="d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                    <Spinner color="primary" />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(OktaCallBackComp);

OktaCallBackComp.propTypes = {
  history: PropTypes.object,
};